module.exports = __webpack_public_path__ + "img/error.2c80f426.png";